import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { currentUserFirstLastNameSelector } from 'redux/selectors';
import useProfileData from './hooks/useProfileData';
import { truthyDadValues } from './common';

/**
 * This displays the current development environment (dev, uat, prod) and
 * the name of the user if running as someone else.
 */
const EnvironmentInfoBar = () => {
  const isLoading = useProfileData();
  const isRunningAs = useSelector((state: any) =>
    truthyDadValues.includes(
      state?.Profile?.BIOGRAPHICAL?.IS_RUNNING_AS ?? false
    )
  );
  const { sName = '' } = useSelector(currentUserFirstLastNameSelector) as {
    sName: string;
  };

  const environment = process.env.REACT_APP_STAGE || 'dev';
  const showEnvironmentInfoBar =
    !isLoading && (environment !== 'prod' || isRunningAs);

  // Publish the bar's height as --env-bar-height so fixed-position overlays
  // can offset below it without having to know this component exists.
  const oBarRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const oRoot = document.documentElement;
    if (!showEnvironmentInfoBar) {
      oRoot.style.setProperty('--env-bar-height', '0px');
      return undefined;
    }
    const update = () => {
      const nHeight = oBarRef.current?.getBoundingClientRect().height ?? 0;
      oRoot.style.setProperty('--env-bar-height', `${nHeight}px`);
    };
    update();
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
      oRoot.style.setProperty('--env-bar-height', '0px');
    };
  }, [showEnvironmentInfoBar, isRunningAs, environment, sName]);

  return showEnvironmentInfoBar ? (
    <div ref={oBarRef} className='environmentInfoBar'>
      {environment !== 'prod' && (
        <p className='t-paragraph--small'>
          <strong>Test environment</strong> - {environment}
        </p>
      )}
      {isRunningAs && (
        <p className='t-paragraph--small'>
          Running as <strong>{sName}</strong>
        </p>
      )}
    </div>
  ) : null;
};

export default EnvironmentInfoBar;
